export default __webpack_public_path__ + "static/CPFL-8aec5a3a47aaedf7b3be1d6a5525a427.png";